import React, { useEffect, useState } from 'react'
import { useRef } from 'react';
import {
  FormGroup, FormControlLabel, Checkbox, Typography
} from "@mui/material";
import Grid from '@mui/material/Grid';
import { styled } from '@mui/material/styles';
import TextField from '@mui/material/TextField';
import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import NavigateNextIcon from '@mui/icons-material/NavigateNext';
import KeyboardArrowLeftIcon from '@mui/icons-material/KeyboardArrowLeft';
import axios from "../../../lib/axios";
import { toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { ToastContainer } from 'react-toastify';
import { useNavigate, useLocation } from 'react-router-dom';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';
import checkAndLock from "../../../GlobalFunction/checkAndLock";
import UnLock from "../../../GlobalFunction/UnLock";
import CrudButtons from '../../../GlobalFunction/CrudButtons';
// import { useModulePermissions } from '../../../GlobalFunction/useModulePermissions';
import ReportTable from '../../../atoms/ReportFolder/ReportTable';
import { useReactToPrint } from 'react-to-print';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import Paper from '@mui/material/Paper';
import Chip from '@mui/material/Chip';
import EditIcon from '@mui/icons-material/Edit';
import DeleteIcon from '@mui/icons-material/Delete';
import { IconButton } from '@mui/material';
import axiosInstance from '../../../lib/axios';
import ConfirmationDialog from '../../ReusableDailog';
import AddIcon from '@mui/icons-material/Add';

const CustomTextField = styled(TextField)(({ theme }) => ({
  '& .MuiFilledInput-root': {
    backgroundColor: 'transparent',
    border: '1px solid #e0e0e0',
    borderRadius: '4px',
  },
  '& .Mui-focused': {
    borderColor: '#673ab7',
  },
  '& .MuiFilledInput-root.Mui-focused': {
    border: '1px solid #673ab7',
  },
}));

const columns = [
  { id: 'RowNum', label: 'S.No.', minWidth: 170 },
  { id: 'InstituteName', label: 'Institute', minWidth: 100 },
  { id: 'Addr', label: 'Address', minWidth: 100 },
  { id: 'RouteNo', label: 'RouteNo', minWidth: 100 },
  { id: 'Remark', label: 'Remark', minWidth: 100 }
];

const InstituteMaster = () => {
  const [formData, setFormData] = useState({
    InstituteName: '',
    Addr: '',
    Remark: '',
    RouteNo: '',
  });

  // const permissions = useModulePermissions("Institute Master");

  const [error, setError] = useState({
    instituteName: false,
    addr: false,
    remark: false
  });

  const navigate = useNavigate();

  const [isFormDisabled, setIsFormDisabled] = useState(true);
  const location = useLocation();
  const [currentInstituteId, setCurrentInstituteId] = useState(null);
  const [mode, setMode] = useState('view');
  const [lastInsertedInstituteId, setLastInsertedInstituteId] = useState(null);
  const [openConfirmDialog, setOpenConfirmDialog] = useState(false);
  const [UserId, setUserId] = useState(sessionStorage.getItem('UserId'));
  const [Status, setStatus] = useState("1");
  const [DataForPrint, setDataForPrint] = useState({});
  const [openCheckoutConfirm, setOpenCheckoutConfirm] = useState(false);
  const [rows, setRows] = useState([]);
  const contentRef = useRef(null);
  const handlePrint = useReactToPrint({ contentRef });

  const [openLocationDialog, setOpenLocationDialog] = useState(false);
  const [locationData, setLocationData] = useState({
    tiffin_Loc: '',
    status: true,
    remarks: ''
  });
  const [locationList, setLocationList] = useState([]);
  const [editLocationId, setEditLocationId] = useState(null);
  const instituteNameRef = useRef(null);
  const addrRef = useRef(null);
  const remarkRef = useRef(null);
  const routeRef = useRef(null);

  const fetchLocations = async () => {
    try {
      const response = await axiosInstance.post(`MstInstitute/RetriveMstInstituteDtl`, {
        InstituteId: currentInstituteId,
        Flag: "P"
      });
      if (response.data.Status === 0 && response.data.responseStatusCode === 1) {
        setLocationList(response.data.Data || []);
      }
    } catch (error) {
      console.error('Error fetching locations:', error);
    }
  };

  useEffect(() => {
    if (currentInstituteId) {
      fetchLocations();
    }
  }, [currentInstituteId]);


  const handleLocationChange = (event) => {
    const { name, value } = event.target;
    setLocationData(prev => ({
      ...prev,
      [name]: value
    }));
  };

  const handleLocationStatusChange = (event) => {
    setLocationData(prev => ({
      ...prev,
      status: event.target.checked
    }));
  };

  const handleSaveLocation = async () => {
    if (!locationData.tiffin_Loc) {
      toast.error('Location is required');
      return;
    }

    try {
      const payload = {
        instituteId: currentInstituteId,
        tiffin_Loc: locationData.tiffin_Loc,
        status: locationData.status ? "1" : "0",
        remarks: locationData.remarks
      };

      if (editLocationId) {
        payload.locationId = editLocationId;
        const response = await axiosInstance.post(`MstInstitute/UpdateMstInstituteDtl`, payload);
        toast.success(response.data.Message || 'Location updated successfully');
      } else {
        const resposne = await axiosInstance.post(`MstInstitute/InsertMstInstituteDtl`, payload);
        toast.success(resposne.data.Message || 'Location added successfully');
      }
      setOpenLocationDialog(false);
      resetLocationForm();
      fetchLocations();
    } catch (error) {
      toast.error('Error saving location');
    }
  };

  const handleEditLocation = (loc) => {
    setEditLocationId(loc.InstituteId || loc.id);
    setLocationData({
      tiffin_Loc: loc.Tiffin_Loc,
      status: loc.Status === "1",
      remarks: loc.Remarks || ''
    });
    setOpenLocationDialog(true);
  };

  const handleDeleteLocation = async (loc) => {
    const payload = {
      instituteId: loc.InstituteId,
      tiffin_Loc: loc.Tiffin_Loc
    };

    try {
      const response = await axiosInstance.post(`MstInstitute/DeleteMstInstituteDtl`, payload);
      toast.success(response.data.Message || 'Location deleted successfully');
      fetchLocations();
    } catch (error) {
      toast.error('Error deleting location');
    }

  };

  const resetLocationForm = () => {
    setLocationData({
      tiffin_Loc: '',
      status: true,
      remarks: ''
    });
    setEditLocationId(null);
  };

  useEffect(() => {
    if (location.state && location.state.InstituteId) {
      setCurrentInstituteId(location.state.InstituteId);
      fetchInstituteData(location.state.InstituteId);
      setMode('view');
    } else {
      setMode('add');
      setIsFormDisabled(false);
    }
  }, [location]);

  const fetchInstituteData = async (id, flag) => {
    try {
      const response = await axios.post(`MstInstitute/RetriveMstInstitute`, {
        InstituteId: parseInt(id),
        Flag: flag
      });

      if (response.data.Status === 0 && response.data.responseStatusCode === 1) {
        const instituteData = response.data.Data[0];
        setFormData({
          InstituteName: instituteData.InstituteName,
          Addr: instituteData.Addr,
          Remark: instituteData.Remark,
          RouteNo: instituteData.RouteNo,
        });
        setStatus(instituteData.Status.toString() || "0");
        setIsFormDisabled(true);
        setCurrentInstituteId(instituteData.InstituteId);
      } else if (response.data.Status === 1 && response.data.responseStatusCode === 2) {
        toast.info(response.data.Message);
      } else {
        toast.error('Failed to fetch institute master data');
      }
    } catch (error) {
      toast.error('Error fetching institute master data. Please try again.');
    }
  };

  useEffect(() => {
    const getRow = async () => {
      const params = {
        start: 1,
        PageSize: 1,
        SearchText: ""
      };

      try {
        const res = await axios.post('MstInstitute/getAllMstInstituteDashBoard', { params });

        if (res.data && res.data.Data) {
          setRows(res.data.Data);
          setDataForPrint(res.data.Data);
        }
      } catch (err) {
        console.error('Error fetching data:', err);
      }
    };

    getRow();
  }, []);

  const handlePrevious = async () => {
    if (currentInstituteId && currentInstituteId > 1) {
      await fetchInstituteData(currentInstituteId, "P");
      await fetchLocations();
    }
  };

  const handleNext = async () => {
    if (currentInstituteId) {
      await fetchInstituteData(currentInstituteId, "N");
      await fetchLocations();
    }
  };

  const handleInputChange = (event) => {
    const { name, value } = event.target;
    setFormData(prevState => ({
      ...prevState,
      [name]: value
    }));

    if (name === 'institute') {
      setFormData(prevState => ({
        ...prevState,
        state: ''
      }));
    }

    if (name === 'institute' && value !== '') {
      setTimeout(() => {
        remarkRef.current.focus();
      }, 100000);
    }
  };

  const handleChangeStatus = (event) => {
    const updatedStatus = event.target.checked ? "1" : "0";
    setStatus(updatedStatus);
  };

  const handleKeyPress = (event) => {
    if (event.key === 'Enter') {
      if (event.target === addrRef.current) {
        remarkRef.current.focus();
      } else {
        addrRef.current.focus();
      }
    }
  };

  const handleSave = async () => {

    let hasError = false;

    if (!formData.InstituteName) {
      toast.error('Institute name is required');
      setError(prev => ({ ...prev, instituteName: true }));
      hasError = true;
    } else {
      setError(prev => ({ ...prev, instituteName: false }));
    }

    if (hasError) {
      return;
    }

    try {
      const payload = {
        InstituteName: formData.InstituteName,
        Addr: formData.Addr,
        Remark: formData.Remark,
        RouteNo: formData.RouteNo,
        Status: Status
      };

      let response;
      if (mode === 'edit') {
        payload.InstituteId = currentInstituteId;
        payload.UpdatedBy = parseInt(UserId, 10);
        response = await axios.patch(`MstInstitute/UpdateMstInstitute`, payload);
      } else {
        payload.CreatedBy = parseInt(UserId, 10);
        response = await axios.post(`MstInstitute/InsertMstInstitute`, payload);
      }

      if (response.data.Status === 0 && response.data.responseStatusCode === 1) {
        toast.success(response.data.Message);
        if (mode === 'add') {
          setLastInsertedInstituteId(response.data.Data)
          await fetchInstituteData(response.data.Data);
          setMode('view');
          setIsFormDisabled(true);
          setCurrentInstituteId(response.data.Data);
        } else {
          setMode('view');
        }
        setIsFormDisabled(true);
      } else {
        toast.error(response.data.Message || 'Operation failed');
      }
    } catch (error) {
      toast.error('Error saving/updating Institute Master. Please try again.');
    }
  };

  const handleEdit = async () => {

    let Flag = await checkAndLock(currentInstituteId, "MstInstitute", "InstituteId");
    switch (Flag) {
      case 0:
        setMode("edit");
        setIsFormDisabled(false);
        break;
      case 1:
        toast.info("Record  Already Locked", { autoClose: 500 });
        break;
      case 2:
        toast.info("Record Failed To Locked", { autoClose: 500 });
        break;
      default:
        toast.info("Something Went Wrong", { autoClose: 500 });
    }
  };

  const handleAdd = () => {
    setMode('add');
    setIsFormDisabled(false);
    setFormData({
      InstituteName: '',
      Addr: '',
      Remark: '',
      RouteNo: '',
    });
    setLocationList([]);
    setCurrentInstituteId(null);

    setTimeout(() => {
      instituteNameRef.current.focus();
    }, 0);
  };

  const handleCancel = async () => {
    try {
      await fetchInstituteData(1, "L");
      await UnLock(currentInstituteId, "MstInstitute", "InstituteId");
      setMode('view');
      setIsFormDisabled(true);
    } catch (error) {
      toast.error('Error occurred while cancelling. Please try again.');
    }
  };

  const resetForm = () => {
    setFormData({
      InstituteName: '',
      Addr: '',
      Remark: '',
      RouteNo: ''
    });
    setCurrentInstituteId(null);
    setMode('view');
  };

  const handleExit = () => {
    navigate('/instituteMasterTable')
  }

  const handleDeleteClick = () => {
    setOpenConfirmDialog(true);
  };

  const handleCloseConfirmDialog = () => {
    setOpenConfirmDialog(false);
  };

  const handleConfirmDelete = async () => {

    let Flag = await checkAndLock(currentInstituteId, "MstInstitute", "InstituteId");
    switch (Flag) {
      case 0:
        setOpenConfirmDialog(false);
        await fetchInstituteData(currentInstituteId, "D");
        await fetchInstituteData(currentInstituteId, "N");
        setMode('view');
        setIsFormDisabled(true);
        break;
      case 1: toast.info("Record  Already Locked", { autoClose: 500 });
        break;
      case 2: toast.info("Record Failed To Locked", { autoClose: 500 });
        break;
      default: toast.info("Something Went Wrong", { autoClose: 500 });
    }
  };

  const handleDeleteAllLocations = async () => {
    try {
      const payload = {
        instituteId: currentInstituteId
      };
      const response = await axiosInstance.post(`MstInstitute/DeleteMstInstituteDtl`, payload);
      toast.success(response.data.Message || 'All locations deleted successfully');
      fetchLocations();
      setOpenCheckoutConfirm(false);
    } catch (error) {
      toast.error('Error deleting all locations');
    }
  }

  return (
    <>
      <Box className="form-container" sx={{ height: { xs: '700px', sm: '550px' } }}>
        <ToastContainer />
        <Grid container spacing={2} className='form_grid'>
          <Grid item xs={12} className='form_title'
            sx={{
              display: 'flex', alignItems: 'center',
              justifyContent: 'space-between', marginTop: '20px',
              flexDirection: { xs: 'column', sm: 'row', md: 'row' }
            }}
          >
            <Grid
              sx={{
                display: 'flex',
                justifyContent: { xs: 'center', sm: 'flex-start' },
                marginBottom: { xs: '10px', sm: 0 }
              }}
            >
              <Button
                variant="contained"
                size="small"
                className='three-d-button-previous'
                onClick={handlePrevious}
                sx={{ backgroundColor: '#635BFF', marginRight: { xs: '5px', sm: '10px' }, display: { xs: 'none', sm: 'block' } }}
                disabled={mode !== 'view' || !currentInstituteId || currentInstituteId === 1}
              >
                <KeyboardArrowLeftIcon />
              </Button>

              <Button
                variant="contained"
                size="small"
                // sx={{ margin: '0px 10px' }}
                className='three-d-button-next'
                sx={{ backgroundColor: '#635BFF', display: { xs: 'none', sm: 'block' } }}
                onClick={handleNext}
                disabled={mode !== 'view' || !currentInstituteId}
              >
                <NavigateNextIcon />
              </Button>
            </Grid>

            <Typography
              variant="h5"
              sx={{
                margin: 'Auto',
                textAlign: { xs: 'center', sm: 'center' },
                fontSize: { xs: '24px', sm: '18px', md: '24px' }
              }}
            >
              Institute Master
            </Typography>

            <Grid sx={{ display: "flex", justifyContent: "end" }}>
              {formData.InstituteName && formData.InstituteName.length > 0 && (
                <Button
                  variant="contained"
                  color="info"
                  size="small"
                  startIcon={<AddIcon />}
                  onClick={() => {
                    resetLocationForm();
                    setOpenLocationDialog(true);
                  }}
                >
                  Location
                </Button>)}

              <CrudButtons
                moduleName="Institute Master"
                mode={mode}
                onAdd={handleAdd}
                onEdit={handleEdit}
                onView={handlePrint}
                onDelete={handleConfirmDelete}
                onExit={handleExit}
                onPrevious={handlePrevious}
                onNext={handleNext}
                readOnlyMode={isFormDisabled}
              />
            </Grid>
          </Grid>

          <Grid item xs={12} className='form_field'>
            <Grid container spacing={2}>
              <Grid item xs={12} md={6} lg={6}>
                <TextField
                  id="InstituteName"
                  name="InstituteName"
                  label={
                    <span>
                      Institute <span style={{ color: 'red' }}>*</span>
                    </span>
                  }
                  variant="filled"
                  fullWidth
                  className="custom-textfield"
                  value={formData.InstituteName}
                  onChange={handleInputChange}
                  disabled={isFormDisabled}
                  error={error.instituteName}
                  helperText={error.instituteName && ""}
                  inputRef={instituteNameRef}
                  onKeyDown={handleKeyPress}
                />
              </Grid>
              <Grid item xs={12} md={6} lg={6}>
                <TextField
                  id="Addr"
                  name="Addr"
                  label="Address"
                  variant="filled"
                  fullWidth
                  className="custom-textfield"
                  value={formData.Addr}
                  onChange={handleInputChange}
                  disabled={isFormDisabled}
                  inputRef={addrRef}
                  onKeyDown={handleKeyPress}
                />
              </Grid>
              <Grid item xs={12} md={6}>
                <TextField
                  fullWidth
                  label="Remark"
                  name="Remark"
                  value={formData.Remark}
                  onChange={handleInputChange}
                  variant="filled"
                  disabled={isFormDisabled}
                  className="custom-textfield"
                  inputRef={remarkRef}
                />
              </Grid>
              <Grid item xs={12} md={4}>
                <TextField
                  fullWidth
                  label="Route No"
                  name="RouteNo"
                  value={formData.RouteNo}
                  onChange={handleInputChange}
                  variant="filled"
                  disabled={isFormDisabled}
                  className="custom-textfield"
                  inputRef={routeRef}
                />
              </Grid>
              <Grid item xs={12} md={6} lg={2}>
                <FormGroup>
                  <FormControlLabel
                    control={
                      <Checkbox
                        disabled={isFormDisabled}
                        checked={Status === "1"}
                        onChange={handleChangeStatus}
                      />
                    }
                    label="Status"
                  />
                </FormGroup>
              </Grid>
            </Grid>
            {locationList.length > 0 && (
              <Grid item xs={12} sx={{ mt: 0, pt: 0 }}>
                <Grid sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', }}>
                  <Typography variant="h6" sx={{ mb: 0.5 }}>Location List</Typography>
                  <Button sx={{ fontSize: '12px', fontWeight: 'bold', textTransform: 'none' }} size='small' variant="outlined" color="error" onClick={() => setOpenCheckoutConfirm(true)}>
                    Delete All
                  </Button>
                </Grid>
                <TableContainer component={Paper}>
                  <Table size="small">
                    <TableHead sx={{ bgcolor: '#635BFF' }}>
                      <TableRow>
                        <TableCell sx={{ color: 'white', py: 0.3, px: 1 }}>S.No.</TableCell>
                        <TableCell sx={{ color: 'white', py: 0.3, px: 1 }}>Location</TableCell>
                        <TableCell sx={{ color: 'white', py: 0.3, px: 1 }}>Remarks</TableCell>
                        <TableCell sx={{ color: 'white', py: 0.3, px: 1 }}>Status</TableCell>
                        <TableCell sx={{ color: 'white', py: 0.3, px: 1 }}>Actions</TableCell>
                      </TableRow>
                    </TableHead>
                    <TableBody>
                      {locationList.map((loc, index) => (
                        <TableRow
                          key={loc.LocationId || loc.id}
                          sx={{ '&:last-child td, &:last-child th': { border: 0 } }}
                        >
                          <TableCell sx={{ py: 0, px: 1 }}>{index + 1}</TableCell>
                          <TableCell sx={{ py: 0, px: 1 }}>{loc.Tiffin_Loc}</TableCell>
                          <TableCell sx={{ py: 0, px: 1 }}>{loc.Remarks || '-'}</TableCell>
                          <TableCell sx={{ py: 0, px: 1 }}>
                            <Chip
                              label={loc.Status === "1" ? "Active" : "Inactive"}
                              color={loc.Status === "1" ? "success" : "default"}
                              size="small"
                            />
                          </TableCell>
                          <TableCell sx={{ py: 0, px: 1 }}>
                            <IconButton
                              size="small"
                              color="primary"
                              onClick={() => handleEditLocation(loc)}
                            >
                              <EditIcon fontSize="small" />
                            </IconButton>
                            <IconButton
                              size="small"
                              color="error"
                              onClick={() => handleDeleteLocation(loc)}
                            >
                              <DeleteIcon fontSize="small" />
                            </IconButton>
                          </TableCell>
                        </TableRow>
                      ))}
                    </TableBody>
                  </Table>
                </TableContainer>
              </Grid>
            )}
          </Grid>

          <Grid item xs={12} className="form_button">
            {mode === 'view' && (
              <>
                <Button variant="contained" sx={{ mr: 1, background: 'linear-gradient(290deg, #d4d4d4, #ffffff)' }} onClick={handleAdd} disabled>
                  Submit
                </Button>
                <Button variant="contained" sx={{ mr: 1, background: 'linear-gradient(290deg, #a7c5e9, #ffffff)' }} onClick={handleEdit}
                  disabled
                >
                  Cancel
                </Button>
              </>
            )}
            {(mode === 'edit' || mode === 'add') && (
              <>
                <Button variant="contained" sx={{ mr: 1 }} onClick={handleSave}>
                  Submit
                </Button>
                <Button variant="contained" sx={{ mr: 1 }} onClick={handleCancel}>
                  Cancel
                </Button>
              </>
            )}
          </Grid>
        </Grid>
      </Box>

      <div style={{ display: 'none' }}>
        {Object.keys(DataForPrint).length > 0 && <ReportTable
          columns={columns}
          rows={rows}
          title="Institute Master"
          contentRef={contentRef}
          customStyles={{ backgroundColor: '#f5f5f5' }}
        />
        }
      </div>

      <Dialog
        open={openLocationDialog}
        onClose={() => setOpenLocationDialog(false)}
        maxWidth="sm"
        fullWidth
      >
        <DialogTitle>
          {editLocationId ? 'Edit Location' : 'Add Location'}
        </DialogTitle>
        <DialogContent>
          <Grid container spacing={2} >
            <Grid item xs={12}>
              <TextField
                className="custom-textfield"
                fullWidth
                label="Location"
                name="tiffin_Loc"
                variant='filled'
                value={locationData.tiffin_Loc}
                onChange={handleLocationChange}
                required
                disabled={editLocationId}
              />
            </Grid>
            <Grid item xs={12}>
              <TextField
                className="custom-textfield"
                fullWidth
                label="Remarks"
                name="remarks"
                variant='filled'
                value={locationData.remarks}
                onChange={handleLocationChange}
                multiline
                rows={2}
              />
            </Grid>
            <Grid item xs={12}>
              <FormGroup>
                <FormControlLabel
                  control={
                    <Checkbox
                      checked={locationData.status}
                      onChange={handleLocationStatusChange}
                    />
                  }
                  label="Status"
                />
              </FormGroup>
            </Grid>
          </Grid>
        </DialogContent>
        <DialogActions>
          <Button onClick={() => setOpenLocationDialog(false)} variant="outlined">
            Cancel
          </Button>
          <Button onClick={handleSaveLocation} variant="contained" color="primary">
            {editLocationId ? 'Update' : 'Save'}
          </Button>
        </DialogActions>
      </Dialog>

      <Dialog
        open={openConfirmDialog}
        onClose={handleCloseConfirmDialog}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        <DialogTitle id="alert-dialog-title">
          {"Confirm Deletion"}
        </DialogTitle>
        <DialogContent>
          <DialogContentText id="alert-dialog-description">
            Are you sure you want to delete this record?
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button
            sx={{
              backgroundColor: '#635bff',
              color: 'white',
              '&:hover': {
                backgroundColor: '#1565c0',
                color: 'white'
              }
            }}
            onClick={handleConfirmDelete}
          >
            Yes
          </Button>
          <Button
            sx={{
              backgroundColor: '#635bff',
              color: 'white',
              '&:hover': {
                backgroundColor: '#1565c0',
                color: 'white'
              }
            }}
            onClick={handleCloseConfirmDialog}
          >
            No
          </Button>
        </DialogActions>
      </Dialog>
      <ConfirmationDialog
        open={openCheckoutConfirm}
        onClose={() => setOpenCheckoutConfirm(false)}
        onConfirm={handleDeleteAllLocations}
        title="Confirm Delete"
        message="Are you sure you want to delete all locations?"
      />
    </>
  )
}

export default InstituteMaster